module.exports = __webpack_public_path__ + "static/media/share.7c4bce4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/value-investment/share.png
// module id = 356
// module chunks = 0